import React from "react";
import {Colors, ServiceImages} from "../Types";

const titleColors = Object.freeze<Partial<Record<Colors, string>>>({
  quaternary: 'text-quaternary',
  accentWoman: 'text-accentWoman',
  white: 'text-white'
});

// Every service uses the same boxes, so icons, titles, rules and text line up from one item to the next
const Service: React.FC<Props> = (
  {
    header,
    text,
    icon,
    headerTextColor
  }
) => {
  return (
    <li className="pt-10 text-center">
      <div className="h-[100px] mb-2 flex items-end justify-center">
        <div className={`bg-image ${icon} w-[100px] h-[100px]`}/>
      </div>
      <h3 className={`font-serif font-medium text-[28px] leading-[1.15] whitespace-nowrap ${titleColors[headerTextColor]}`}>{header}</h3>
      <div className="w-[120px] h-px mx-auto mt-[18px] bg-white/75"/>
      <p className="max-w-[300px] mx-auto mt-4 text-[15px] leading-[1.65] text-white/[.88]">{text}</p>
    </li>
  );
};

export default Service;

interface Props {
  header: string,
  text: string,
  icon?:ServiceImages,
  headerTextColor:Colors,
  textColor?:Colors
}
